import { removeCookie, setCookie } from "../../helpers/authHelper";
import * as api from "../api";
import toast from "react-hot-toast";
import CustomToast from "../../components/CustomToast";

export const SIGNIN_USER = "SIGNIN_USER";
export const SUCCESS_SUPER_ADMIN = "SUCCESS_SUPER_ADMIN";
export const LOGOUT_USER = "LOGOUT_USER";
export const SET_USER = "SET_USER";
export const INITIAL_LOADER = "INITIAL_LOADER";

export const signin =
  (payload, handleSuccess, handleError) => async (dispatch) => {
    try {
      const response = await api.apiSigninUser(payload);

      if (response.data.role.name === "ROLE_COLLECTOR") {
        const err = {
          message: "Collectors cannot login the webapp.",
        };
        handleError(err);
      } else {
        const userData = {
          name: response.data.name,
          email: response.data.email,
          mobileNumber: response.data.mobileNumber,
          role: response.data.role.name,
          sahakari: response.data.sahakari,
          username: response.data.username,
        };
        const accessToken = response.data.access_token;
        const refreshToken = response.data.refresh_token;
        setCookie("refreshToken", refreshToken);

        handleSuccess();
        dispatch({
          type: SUCCESS_SUPER_ADMIN,
          userData,
          accessToken,
          refreshToken,
        });
      }
    } catch (err) {
      handleError(err);
    }
  };

export const getUser =
  (token, handleSuccess, handleFailure) => async (dispatch) => {
    try {
      const response = await api.apiGetUser(token);
      const accessToken = response.data.access_token;
      const refreshToken = response.data.refresh_token;
      const userData = {
        name: response.data.name,
        email: response.data.email,
        mobileNumber: response.data.mobileNumber,
        role: response.data.role.name,
        sahakari: response.data.sahakari,
        username: response.data.username,
      };
      dispatch({ type: SET_USER, accessToken, refreshToken, userData });
    } catch (e) {
      if (e?.message === "Network Error") {
      } else {
        removeCookie("refreshToken");
      }
    }
  };

export const logoutUser = () => {
  removeCookie("refreshToken");
  toast.dismiss();

  CustomToast({
    position: "bottom-right",
    title: "Logged out successfully!",
    toastType: "success",
    duration:4000
  });

  return { type: LOGOUT_USER };
};

export const setInitialLoading = (val) => {
  return { type: INITIAL_LOADER, payload: val };
};
